import DOMPurify from 'dompurify';

// Kept here rather than in utils so this module imports nothing but DOMPurify —
// utils pulls in @cuemath/rest-api, whose ESM build jest cannot load.
export const sanitizeHtml = html =>
  DOMPurify.sanitize(html, { ADD_ATTR: ['class'], FORBID_TAGS: ['style'] });

// Marketing preheaders pad themselves with these; a browser paints nothing.
const INVISIBLE_CHARS = /[​-‍⁠﻿­͏]/g;

// Measured on the sanitized DOM, not the raw html: the bubble renders
// sanitizeHtml(...), so a <style>- or <script>-only body paints nothing even
// though its markup is full of text.
export const hasRenderableBody = item => {
  if (item.mediaUrl && item.messageType !== 'TEXT') return true;

  // Mirrors the render, which prefers htmlContent and only falls back to body
  // when there is none. Treating them as alternatives called a truthy-but-blank
  // html renderable whenever content held anything — an appended corporate
  // disclaimer was enough — and left the bubble empty.
  if (!item.htmlContent) return !!(item.body || '').trim();

  const doc = new DOMParser().parseFromString(
    sanitizeHtml(item.htmlContent),
    'text/html',
  );
  const text = (doc.body.textContent || '').replace(INVISIBLE_CHARS, '').trim();

  return !!(text || doc.body.querySelector('img'));
};

const REPLY_SUBJECT_PREFIX = /^\s*((re|fwd|fw|aw|antw|sv|tr|vs)\s*(\[\d+\])?\s*:\s*)+/i;

// Senders sometimes put their whole message in the subject line, so an otherwise
// empty bubble should surface it. A reply/forward subject only echoes the thread's
// own subject, and showing that would read as a message the customer never sent.
export const shouldShowEmailSubject = item => {
  const subject = (item.emailSubject || '').trim();

  return !!subject && !REPLY_SUBJECT_PREFIX.test(subject) && !hasRenderableBody(item);
};
